import { request } from '@/utils/request'
import qs from 'qs'

// 邀请会员人数统计
export function getInviteeCount(params: any) {
  return request({
    url: '/zhongcaijie/h5/invitee/getInviteeCount',
    method: 'get',
    params,
  })
}

// 邀请会员列表
export function getInviteeRecordList(params: any) {
  return request({
    url: '/zhongcaijie/h5/invitee/getInviteeRecordList',
    method: 'get',
    params,
  })
}

// 会员列表
export function getH5MemberList() {
  return request({
    url: '/zhongcaijie/h5/member/getH5MemberList',
    method: 'get',
  })
}

// 会员宣传海报
export function getPosterByType() {
  return request({
    url: '/zhongcaijie/h5/employee/getPosterByType',
    method: 'get',
    params: { type: 1 },
  })
}

// 获取海报列表
// type 1 会员
// type 2 资讯
// type 3 邀请有礼
// type 4 助创活动
export function getPoster(params: any) {
  return request({
    url: '/zhongcaijie/h5/poster/getPoster',
    method: 'get',
    params,
  })
}

// 权益包
// used	优惠券状态 0未使用 1已使用 2已过期
export function getH5RightsPackageList(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/getH5RightsPackageList',
    method: 'get',
    params,
  })
}

// 权益包列表
export function usePackage(data: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/usePackage',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: data,
  })
}

// 权益包（商品优惠券）可用商品
export function getPackageUseGoodsList(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/getPackageUseGoodsList',
    method: 'get',
    params,
  })
}

// 成长值记录
export function getH5UserGrowthRecord(params: any) {
  return request({
    url: '/zhongcaijie/h5/growth/getH5UserGrowthRecord',
    method: 'get',
    params,
  })
}

// 成长值权益兑换记录
export function getGrowthRightsGetRecord(params: any) {
  return request({
    url: '/zhongcaijie/h5/growthRights/getGrowthRightsGetRecord',
    method: 'get',
    params,
  })
}

// 根据成长值等级ID获取成长值等级权益项
export function getGrowthLevelRights(params: any) {
  return request({
    url: '/zhongcaijie/h5/growthRights/getGrowthLevelRights',
    method: 'get',
    params,
  })
}

// 使用权益
export function useGrowthRights(params: any) {
  return request({
    url: '/zhongcaijie/h5/growthRights/useGrowthRights',
    method: 'post',
    params,
  })
}

// 会员成长值列表
export function getH5GrowthList() {
  return request({
    url: '/zhongcaijie/h5/growth/getH5GrowthList',
    method: 'get',
  })
}

// 会员成长值列表
export function getWaitCheckRightsPackage() {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/getWaitCheckRightsPackage',
    method: 'get',
  })
}

// 将权益包状态改成待领取
export function updatePackageWaitReceive(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/updatePackageWaitReceive',
    method: 'post',
    params,
  })
}

// 查询赠送详情
export function getH5GiveRightsPackageInfo(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/getH5GiveRightsPackageInfo',
    method: 'get',
    params,
  })
}

// 领取赠送的权益包
export function receiveGivePackage(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/receiveGivePackage',
    method: 'post',
    params,
  })
}

// 获取权益包详情
export function getReceiveGivePackageMsg(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/getReceiveGivePackageMsg',
    method: 'get',
    params,
  })
}

// 权益对比图
export function getGrowthBindRightsView() {
  return request({
    url: '/zhongcaijie/h5/growthRights/getGrowthBindRightsView',
    method: 'GET',
  })
}
